module.exports = __webpack_public_path__ + "static/media/IconUser.6b8b06b0.svg";